<template>
  <div class="row">

    <div
      v-if="display === 'list'"
      class="p2p-result-row-wrapper"
    >
      <div
        v-for="(p2p, index) in results"
        :key="index"
        class="p2p-result-row"
      >

        <PointToPoint1R
          v-if="p2p.type === '1r'"
          :p2pResult="p2p"
        />

        <PointToPoint2R
          v-if="p2p.type === '2r'"
          :p2pResult="p2p"
        />

      </div>
    </div>


    <div v-if="display === 'detail'">
      <PointToPointDetail/>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex';
import PointToPoint1R from "./P2p1r/PointToPoint1R";
import PointToPoint2R from "./P2p2r/PointToPoint2R";
import PointToPointDetail from './PointToPointDetail';

export default {
  name: "PointToPointResults",
  components: {
    PointToPoint1R,
    PointToPointDetail,
    PointToPoint2R,
  },
  computed: {
    ...mapState('p2p', ['results', 'detail', 'display']),
  },
}
</script>

<style scoped>
.p2p-result-row {
  border-bottom: 1px solid grey;
  padding: 8px;
}

</style>
